import React, { useEffect, useState } from 'react'
import { Select } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { getOrdinanceTypes } from '../../../services/OdvService'
import useNotifications from '../../../hooks/useNotifications'

export default function OdvOrdinanceSelect({ label, placeholder, value, onChange, country }) {
  const { error } = useNotifications()
  const { t } = useTranslation()
  const [ordinances, setOrdinances] = useState([])

  useEffect(() => {
    let isCurrent = true
    getOrdinanceTypes(country)
      .then((response) => {
        if (isCurrent && response.data) {
          setOrdinances(
            response.data.map((ordinance) => {
              return {
                value: `${ordinance}`,
                label: t(`odv.ordinance.${ordinance}`, ordinance),
              }
            })
          )
        }
      })
      .catch((err) => {
        error(`Failed to get ordinances: ${err?.response?.statusText}`, err)
      })
    return () => {
      isCurrent = false
    }
  }, [error, country, t])

  return (
    <Select
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      options={ordinances}
    />
  )
}
